'use client';

import { telemetryIncrementAction } from 'core-events/actions';
import type { JSX, MouseEvent, PropsWithChildren } from 'react';

const PLAN_CTA_CLICK_TAG = 'pricing.plan_cta.click';

/** Builder owns every pricing CTA's markup, so clicks are matched by destination, not by component. */
export default function PlanCtaTelemetry({ children }: PropsWithChildren): JSX.Element {
    return <div onClickCapture={reportPlanCtaClick}>{children}</div>;
}

function reportPlanCtaClick(event: MouseEvent<HTMLDivElement>): void {
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (anchor instanceof HTMLAnchorElement && isSignUpPath(anchor.pathname)) {
        void telemetryIncrementAction(PLAN_CTA_CLICK_TAG);
    }
}

function isSignUpPath(pathname: string): boolean {
    return pathname === '/sign-up' || pathname.startsWith('/sign-up/');
}
